<template>
  <div class="detail">
    <div class="title">{{$t('lang.menu.Terms')}}</div>
    <div class="detailContainer">
      <div v-for="(item, index) in termsList" :key="index" :class="item.class" v-html="item.content"></div>
      <div class="bottomLogo">
        <img :src="logo" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/images/common/logo1.svg'

export default {
  name: 'TermsAndConditions',
  data () {
    return {
      logo,
      termsList: this.$t('lang.terms')
    }
  }
}
</script>

<style lang="less" scoped>
  .detail {
    height: 100%;
    overflow: auto;
    padding-right: 10px;
    .title {
      font-size: 22px;
      line-height: 26px;
      color: #F6D9AA;
      font-weight: bold;
      margin-bottom: 16px;
    }
    .detailContainer {
      height: 100%;
      .t1 {
        font-size: 18px;
        line-height: 21px;
        color: #F6D9AA;
        font-weight: bold;
        margin: 20px 0;
      }
      .t2 {
        font-size: 18px;
        line-height: 140%;
        color: #fff;
        margin-bottom: 12px;
      }
      .t3 {
        display: flex;
        font-size: 16px;
        line-height: 19px;
        color: #fff;
        margin-bottom: 10px;
        i {
          margin-left: 10px;
        }
      }
      .bottomLogo {
        text-align: right;
        img {
          width: 40px;
        }
      }
    }
    &::-webkit-scrollbar {
      width: 3px;
      height: 100%;
    }
    &::-webkit-scrollbar-track {
      width: 3px;
      height: 100%;
      background-color: transparent;
      border-radius: 33px;
    } /* 滚动条的滑轨背景颜色 */
    &::-webkit-scrollbar-thumb {
      width: 3px;
      border-radius: 33px;
      background-color: #F6D9AA;
    } /* 滑块颜色 */
  }
</style>



// WEBPACK FOOTER //
// src/pages/Documents/Terms.vue